import {Accordion, AccordionDetails, AccordionSummary, Card, Grid} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import {SwitchSegmentedYesNo, TextBox} from '../../../Core/UI';
import {DatePicker, MuiPickersUtilsProvider} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import React from 'react';
import {observer} from 'mobx-react-lite';
import {HealthQuestionsProps} from './HealthQuestionsList';
import {Parameter} from '../../../Core/mobx/ParameterStore/ParameterStore';

const HeartDisease = observer(({counter, valueChanged, parameters, coreQuestions}: HealthQuestionsProps) => {
    return (
        <Accordion style={{width: '100%'}} TransitionProps={{unmountOnExit: true}}>
            <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls={'Heartdisease-content'}
                id={'Heartdisease-header'}
            >
                <div style={{display: 'flex', justifyContent: 'space-between', width: '100%'}}>
                    <div>Heart disease</div>
                    <div>{counter('heartDisease')}</div>
                </div>
            </AccordionSummary>
            <AccordionDetails>
                <Grid container>
                    <Grid key="params" container>
                        {coreQuestions?.map(({name, label}) => (
                            <Grid item xs={4} key={name}>
                                <SwitchSegmentedYesNo
                                    param={{
                                        name: name,
                                        label: label,
                                        category: 'heartDisease',
                                        ...(parameters[name as keyof typeof parameters] as Parameter),
                                    }}
                                    required={''}
                                    valueChanged={valueChanged}
                                />
                            </Grid>
                        ))}
                        {parameters.HeartFailure.value && (
                            <Grid item xs={12} style={{marginTop: 10}}>
                                <Card style={{padding: 20}}>
                                    <strong>Heart Failure</strong>
                                    <Grid container spacing={3}>
                                        <Grid item xs={6}>
                                            <TextBox
                                                id="heartfailureDiagnosisAge"
                                                label="What age were you diagnosed?"
                                                value={parameters.heartfailureDiagnosisAge?.value}
                                                onChange={(value) =>
                                                    valueChanged(parameters.heartfailureDiagnosisAge, value)
                                                }
                                                type="number"
                                            />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <SwitchSegmentedYesNo
                                                param={{
                                                    name: 'heartfailureBloodThinners',
                                                    label: 'Are you currently taking any blood thinners?',
                                                    ...parameters.heartfailureBloodThinners,
                                                }}
                                                required={''}
                                                valueChanged={valueChanged}
                                            />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <SwitchSegmentedYesNo
                                                param={{
                                                    name: 'heartfailureSurgery',
                                                    label: 'Did you have surgery to repair valves/arteries/bypass?',
                                                    ...parameters.heartfailureSurgery,
                                                }}
                                                required={''}
                                                valueChanged={valueChanged}
                                            />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <TextBox
                                                id="heartfailureTreatment"
                                                label="What treatment was prescribed or completed for this condition?"
                                                value={parameters.heartfailureTreatment?.value}
                                                onChange={(value) =>
                                                    valueChanged(parameters.heartfailureTreatment, value)
                                                }
                                            />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                <DatePicker
                                                    inputVariant="outlined"
                                                    variant="inline"
                                                    openTo="year"
                                                    views={['year', 'month']}
                                                    label="When was your last visit with a cardiologist?"
                                                    style={{width: '100%', marginTop: 8}}
                                                    value={parameters.heartfailureCardiologistVisit?.value || null}
                                                    onChange={(date) =>
                                                        valueChanged(parameters.heartfailureCardiologistVisit, date)
                                                    }
                                                />
                                            </MuiPickersUtilsProvider>
                                        </Grid>
                                    </Grid>
                                </Card>
                            </Grid>
                        )}
                    </Grid>
                </Grid>
            </AccordionDetails>
        </Accordion>
    );
});

export default HeartDisease;
